import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "src/app/data.service";
@Component({
  selector: "app-convertsettinglist",
  templateUrl: "./convertsettinglist.component.html",
  styleUrls: ["./convertsettinglist.component.scss"],
})
export class ConvertsettinglistComponent implements OnInit {
  isLoading = false;
  isError = false;
  errorMessage = "";
  convertsettings = [];
  tabs = [];
  mode = "";
  convertSettingId = "";
  convertSettingName = "";
  objectName = "";
  displayedColumns: string[] = [
    "name",
    "objectname",
    "createdby",
    "modifiedby",
    "modifieddate",
    "map",
  ];
  dataSource: any[] = [];
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      // this.mode = this.route.snapshot.params.mode;
      this.convertSettingId = this.route.snapshot.params.id;
      this.convertSettingName = this.route.snapshot.params.name;
      // this.objectName = this.route.snapshot.params.objectname;
    });
    this.getConvertSettings();
    // this.getConvertSettingsById();
  }

  // fieldmap(id: any, name: any, objectname: any, objectid: any) {
  //   this.router.navigateByUrl(
  //     "/home/convertsetting/fieldmapping/new/" +
  //       id +
  //       "/" +
  //       name +
  //       "/" +
  //       objectname +
  //       "/" +
  //       objectid
  //   );
  // }
  fieldmap(id: any, name: any, objectname: any, objectid: any) {
    this.getConvertSettingsById(id).then((mode: string) => {
      // Determine the URL based on the resolved mode
      console.log(mode);
      const url =
        mode === "edit"
          ? `/home/convertsetting/fieldmapping/edit/${id}/${name}/${objectname}/${objectid}`
          : `/home/convertsetting/fieldmapping/new/${id}/${name}/${objectname}/${objectid}`;

      // Navigate to the determined URL
      this.router.navigateByUrl(url);
    });
  }

  getConvertSettings() {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    // const domain = localStorage.getItem("domain");
    // const subdomain = localStorage.getItem("subdomain");
    const domain = localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`);
    const subdomain = localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`);

    this.isLoading = true;
    this.dataService
      .getConvertSettings(organizationid, domain, subdomain)
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            // alert("Are you sure?")
            // this.router.navigate(['home/globalaction'])
            // window.location.reload();
            // this.folders = res.data.folder;
            this.convertsettings = res.data.convertsettings;

            if (this.convertsettings != null) {
              this.dataSource = this.convertsettings.map((convertsetting) => ({
                id: convertsetting.id,
                name: convertsetting.name,
                objectname: convertsetting.objectname,
                objectid: convertsetting.objectid,
                modifiedby: convertsetting.modifiedby,
                modifieddate: convertsetting.modifieddate,
                createdby: convertsetting.createdby,
              }));
            }
            this.isLoading = false;
          } else {
            console.log("error in getting data");
            this.isLoading = false;
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
        }
      );
  }
  getConvertSettingsById(id: string): Promise<string> {
    return new Promise((resolve, reject) => {
      console.log("getConvertSettingsById");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
        subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
        data: {
          convertsetting: {
            id: id,
          },
        },
      };

      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getConvertSettingsById(postOption).subscribe(
        (res) => {
          console.log("res", res);

          if (res.success == 1) {
            this.tabs = res.data.convertsettings.convertionobjectmappingfield;
            const mode = this.tabs.length > 0 ? "edit" : "new";

            this.isLoading = false;
            resolve(mode); // Resolve the promise with the mode value
          } else {
            console.log("Error while Retrieving");
            this.isLoading = false;
            resolve("new"); // Resolve with a default value if an error occurs
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve("new"); // Resolve with a default value if an error occurs
        }
      );
    });
  }
cancel(){
  this.router.navigateByUrl("/home");

}
  new() {
    this.router.navigateByUrl("/home/convertsetting/new");
  }

  edit(id: any, name: any, objectname: any, objectid: any) {
    this.router.navigateByUrl(
      "/home/convertsetting/edit/" +
        id +
        "/" +
        name +
        "/" +
        objectname +
        "/" +
        objectid
    );
  }

  // editmap(id: any, name: any, objectname: any, objectid: any) {
  //   this.router.navigateByUrl(
  //     "/home/convertsetting/fieldmapping/edit/" +
  //       id +
  //       "/" +
  //       name +
  //       "/" +
  //       objectname +
  //       "/" +
  //       objectid
  //   );
  // }
}
